<template>
  <ul class="row-wrap">
    <li
      v-for="(item, index) in list"
      :key="index"
      class="card-box"
      @click="goDetail(item.goodsId, item)"
    >
      <div class="card-wrap">
        <div class="image-wrap">
          <el-image
            style="width: 170px; height: 170px"
            fit="contain"
            :src="item.cover"
          >
          </el-image>
        </div>
        <div class="card-info bottom">
          <el-tag v-show="!!item.sourceFile" class="ou-like-tag">{{
            item.sourceFile
          }}</el-tag>
          <div class="ou-like-title ou-expand ou-ellipsis">
            {{ item.goodsTitle }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "CardRow",
  props: {
    list: { type: Array },
  },
  data() {
    return {};
  },
  components: {},
  watch: {},
  mounted() {},
  methods: {
    goDetail(goodsId, item) {
      if (item.goodsType != "train") {
        this.$router.push({
          path: "/bookstore/bookstoreDetail",
          query: { goodsId },
        });
      } else {
        this.$router.push({
          path: "/willingLearn/bookstoreDetail",
          query: { goodsId },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.row-wrap {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.card-box {
  cursor: pointer;
  flex: 1;
  max-width: 170px;
  & + .card-box {
    margin-left: 60px;
  }
}
.card-wrap ::v-deep {
  .image-wrap {
    box-shadow: 0 0 3px 2px #f3f3f3;
  }
  .card-info.bottom {
    display: flex;
    align-items: center;
    width: 170px;
    padding: 20px 0;
  }
  .ou-like-tag {
    width: 60px;
    height: 24px;
    line-height: 24px;
    background: #f9fdff;
    border: 1px solid #0081ce;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 400;
    color: #0081ce;
    padding: 0;
    text-align: center;
  }
  .ou-like-title {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    margin-left: 8px;
  }
}
</style>
